// `__APP_BUILD_ID__` is injected by `vite.config.ts`'s `define` — a UTC build timestamp,
// also stamped into `index.html` as a `<meta name="build-id">` tag by the same build.
export const CURRENT_BUILD_ID = __APP_BUILD_ID__
